import {
  Badge,
  Box,
  Button,
  Flex,
  Grid,
  Loader,
  LoadingOverlay,
  Select,
  Text,
  TextInput,
  Title,
  Tooltip,
} from "@mantine/core";
import {
  IconCalendar,
  IconClipboard,
  IconSearch,
  IconStatusChange,
} from "@tabler/icons-react";
import {
  MantineReactTable,
  MRT_ColumnDef,
  MRT_RowSelectionState,
  useMantineReactTable,
} from "mantine-react-table";
import _breadcrumb from "../../../../_base/component/_layout/_breadcrumb";
import { useDebouncedState, useDisclosure, useHotkeys } from "@mantine/hooks";
import { _localization } from "../../../../config/location";
import { useDeferredValue, useEffect, useState } from "react";
import { MessageResponse } from "../../../../model/MessageResponse";
import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  repositoryMdm,
  repositoryPos,
} from "../../../../_base/_const/_constVar";
import {
  formatDateTime,
  formatDateTransfer,
} from "../../../../common/FormatDate/FormatDate";
import { getTblDmEmployeeAll } from "../../../../service/getSelectApi";
import {
  changeSearchValue,
  getValueById,
} from "../../../../_base/helper/FunctionHelper";
import { DatePickerInput } from "@mantine/dates";

type ColumnPinningType = {
  left?: string[];
  right?: string[];
};

const PurchaseOrderReportExcludingPriceInformation = () => {
  const headerRef = React.useRef<HTMLDivElement>(null);
  const [data, setData] = useState<any[]>([]);
  const [isError, setIsError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [isRefetching, setIsRefetching] = useState(false);
  const [rowCount, setRowCount] = useState(0);
  const [height, setHeight] = useState(0);
  const [rowSelection, setRowSelection] = useState<MRT_RowSelectionState>({});
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 20,
  });
  const rowSelectionDeferred =
    useDeferredValue<MRT_RowSelectionState>(rowSelection);
  const [selectIds, setSelectIds] = useState<string[]>([]);
  const [visible, { toggle, open, close }] = useDisclosure(false);

  const navigate = useNavigate();
  const location = useLocation();
  const _searchJson = sessionStorage.getItem(String(location.pathname))
    ? JSON.parse(sessionStorage.getItem(String(location.pathname)) ?? "")
    : null;
  const checkedPinSearch = localStorage.getItem("checkedPinSearch") == "true";
  const [search, setSearch] = useState<any>({
    TrangThai: _searchJson && checkedPinSearch ? _searchJson?.TrangThai : "",
    StartTime: _searchJson && checkedPinSearch ? _searchJson?.StartTime : "",
    EndTime: _searchJson && checkedPinSearch ? _searchJson?.EndTime : "",
  });
  const [keySearch, setKeySearch] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.keySearch : "",
    300
  );
  const [SoCt, setSoCt] = useDebouncedState<string>(
    _searchJson && checkedPinSearch ? _searchJson?.SoCt : "",
    300
  );

  const [dataEmployee, setDataEmployee] = useState<any[]>([]);

  const columns = React.useMemo<MRT_ColumnDef<any>[]>(
    () => [
      {
        accessorKey: "soCt",
        header: "Số chứng từ",
        Cell: ({ row }) => (
          <Tooltip label="Xem chi tiết">
            <Badge
              variant="dot"
              color="green"
              onDoubleClick={() => handleCheckView(row)}
              style={{ cursor: "pointer" }}
            >
              {row.original.soCt}
            </Badge>
          </Tooltip>
        ),
      },
      {
        accessorKey: "ngayCt",
        header: "Ngày chứng từ",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTime(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "ngayLct",
        header: "Ngày lập chứng từ",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTime(renderedCellValue) : ""}</>
        ),
      },
      { accessorKey: "maCty", header: "Mã công ty" },
      { accessorKey: "maCt", header: "Mã chứng từ" },
      {
        accessorKey: "maKh",
        header: "Khách hàng",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maKh, row.original.tenKh]
              .filter((i) => i && String(i).length > 0)
              .join("-")}
          </Text>
        ),
      },
      {
        accessorKey: "maHttt",
        header: "Hình thức thanh toán",
        size: 250,
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maHttt, row.original.tenHttt]
              .filter((i) => i && String(i).length > 0)
              .join("-")}
          </Text>
        ),
      },
      { accessorKey: "tenHttt", header: "Tên hình thức thanh toán", size: 250 },
      { accessorKey: "httt", header: "Loại hình thức thanh toán", size: 250 },
      { accessorKey: "nguoiGd", header: "Người giao dịch" },
      {
        accessorKey: "maBp",
        header: "Bộ phận",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maBp, row.original.tenBp]
              .filter((i) => i && String(i).length > 0)
              .join("-")}
          </Text>
        ),
      },
      { accessorKey: "dienGiai", header: "Diễn giải" },
      {
        accessorKey: "maTtPo",
        header: "Trạng thái PO",
        Cell: ({ row }) => (
          <Text fw={500} size="12.5px">
            {[row.original.maTtPo, row.original.tenTtPo]
              .filter((i) => i && String(i).length > 0)
              .join("-")}
          </Text>
        ),
      },
      { accessorKey: "taoTuPdn", header: "Tạo từ PDN" },
      { accessorKey: "suaTt", header: "Sửa trạng thái" },
      { accessorKey: "tenTrangThai", header: "Trạng thái" },
      { accessorKey: "duyet", header: "Duyệt" },
      { accessorKey: "nguoiDuyet", header: "Người duyệt" },
      { accessorKey: "tenNguoiDuyet", header: "Tên người duyệt" },
      { accessorKey: "ngayDuyet", header: "Ngày duyệt" },
      { accessorKey: "nguoiHuyDuyet", header: "Người hủy duyệt" },
      { accessorKey: "tenNguoiHuyDuyet", header: "Tên người hủy duyệt" },
      { accessorKey: "ngayHuyDuyet", header: "Ngày hủy duyệt" },
      {
        accessorKey: "listChiTietVatTu",
        header: "Danh sách chi tiết vật tư",
        size: 250,
      },
      {
        accessorKey: "cuser",
        header: "Người tạo",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "luser",
        header: "Người sửa",
        Cell: ({ renderedCellValue }) => (
          <Text fw={500} size="12.5px">
            {getValueById(String(renderedCellValue), dataEmployee, "label")}
          </Text>
        ),
      },
      {
        accessorKey: "cdate",
        header: "Ngày tạo",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
      {
        accessorKey: "ldate",
        header: "Ngày sửa",
        Cell: ({ renderedCellValue }: any) => (
          <>{renderedCellValue ? formatDateTransfer(renderedCellValue) : ""}</>
        ),
      },
    ],
    [dataEmployee]
  );

  const handleCheckView = async (row: any) => {
    const url = `/api/v1/CreateSellItem/details?orderNumber=${row.original.soCt}`;
    const response = await repositoryPos.get<MessageResponse<any>>(url);
    if (response && response.success) {
      // Kiểm tra nếu orderNumber chứa "DT"
      if (row.original.soCt.includes("DT")) {
        navigate("/sell/view-order-return", {
          state: {
            orderNumber: row.original.soCt,
            actionType: "view",
          },
        });
      } else {
        navigate("/sell/view-order", {
          state: {
            orderNumber: row.original.soCt,
            actionType: "view",
          },
        });
      }
    }
  };

  const fetchData = async () => {
    setIsLoading(true);
    setIsRefetching(true);
    setIsError(false);
    try {
      let url = `/api/v1/TblDonMuaHang/get-list-no-money?Skip=${
        pagination.pageIndex * pagination.pageSize
      }&Take=${pagination.pageSize}`;

      const params = new URLSearchParams();
      Object.entries(search).forEach(([key, value]) => {
        if (Array.isArray(value) && value.length > 0) {
          value.forEach((item) => params.append(key, String(item)));
        } else if (typeof value === "string" && value.length > 0) {
          params.append(key, value);
        }
      });

      if (keySearch.length > 0) {
        url += `&KeySearch=${keySearch?.trim()}`;
      }

      url += `&${params.toString()}`;

      const res = await repositoryMdm.get<MessageResponse<any>>(url);

      if (res && res.success) {
        const result = res.data;
        setData(result);
        setRowCount(res.totalCount);
      } else {
        setData([]);
      }
    } catch (error) {
      setData([]);
      setIsError(true);
      console.error(error);
      return;
    } finally {
      setIsLoading(false);
      setIsRefetching(false);
      sessionStorage.setItem(
        String(location.pathname),
        JSON.stringify({
          ...search,
          keySearch: keySearch,
          SoCt: SoCt,
        })
      );
    }
  };

  // const exportDataExcel = async () => {
  //   open();
  //   try {
  //     let url = `?Skip=${pagination?.pageIndex}&Take=${pagination.pageSize}`;

  //     const params = new URLSearchParams();
  //     Object.entries(search).forEach(([key, value]) => {
  //       if (Array.isArray(value) && value.length > 0) {
  //         value.forEach((item) => params.append(key, String(item)));
  //       } else if (typeof value === "string" && value.length > 0) {
  //         params.append(key, value);
  //       }
  //     });

  //     if (keySearch.length > 0) {
  //       url += `&KeySearch=${keySearch?.trim()}`;
  //     }

  //     url += `&${params.toString()}`;

  //     const baseUrl = `/api/v1/ItemComparison/export-excel${url}`;

  //     const _url = BASE_API_MDM + baseUrl;
  //     const token = localStorage.getItem("token");

  //     const response = await fetch(_url, {
  //       method: "GET",
  //       headers: {
  //         "Content-Type": "application/vnd.ms-excel",
  //         Authorization: `Bearer ${token?.replace(`"`, "").replace(`"`, "")}`,
  //       },
  //     });

  //     if (!response.ok) {
  //       NotificationExtension.Fails("Export Excel thất bại !");
  //     } else {
  //       const blob = await response.blob();
  //       const urlss = window.URL.createObjectURL(blob);
  //       const _name = new Date().toISOString().slice(0, 10);
  //       let filename = "danh_sach_voucher.xlsx";
  //       const link = document.createElement("a");
  //       link.href = urlss;
  //       link.download = filename;
  //       document.body.appendChild(link);
  //       link.click();
  //       link.remove();
  //       window.URL.revokeObjectURL(url);
  //       NotificationExtension.Success("Export Excel thành công !");
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   } finally {
  //     close();
  //   }
  // };

  const fetchDataEmp = async () => {
    const res = await getTblDmEmployeeAll();

    if (res) {
      const data = res
        .filter((item) => item.id && item.fullname)
        .map((item) => ({
          label: `${item.code} - ${item.fullname}`,
          value: String(item.code),
        }));
      setDataEmployee(data);
    }
  };

  useEffect(() => {
    fetchData();
  }, [pagination?.pageIndex, pagination?.pageSize]);

  useEffect(() => {
    Promise.all([fetchDataEmp()]);
  }, []);

  const getColumnPinningStorage = () => {
    const columnPinningStorage = localStorage.getItem(
      "columnPinningPurchaseOrderReportExcludingPriceInformation"
    );
    return columnPinningStorage
      ? JSON.parse(columnPinningStorage)
      : {
          left: ["mrt-row-select", "mrt-row-numbers"],
          right: ["action"],
        }; // Giá trị mặc định
  };

  // Lưu columnPinning vào state
  const [columnPinning, setColumnPinning] = useState<ColumnPinningType>(
    getColumnPinningStorage()
  );
  // Hàm lưu vào localStorage
  useEffect(() => {
    localStorage.setItem(
      "columnPinningPurchaseOrderReportExcludingPriceInformation",
      JSON.stringify(columnPinning)
    );
  }, [columnPinning]);

  useEffect(() => {
    //   startTransition(() => {
    const valuesList = Object.keys(rowSelectionDeferred);
    setSelectIds(valuesList);
    if (valuesList.length < 1) setSelectIds([]);
    else {
      const valuesList = Object.keys(rowSelectionDeferred);
      setSelectIds(valuesList);
    }
    //  });
  }, [rowSelectionDeferred]);

  useEffect(() => {
    const headerHeight = headerRef.current?.offsetHeight || 0;
    const handleResize = () => {
      setHeight(window.innerHeight - (185 + headerHeight));
    };

    handleResize(); // Set initial height
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const table = useMantineReactTable({
    columns,
    data,
    enableColumnResizing: false,
    positionToolbarAlertBanner: "bottom",
    enableRowNumbers: true,
    //add custom action buttons to top-left of top toolbar
    enableTopToolbar: false,
    mantineTopToolbarProps: {
      style: {
        borderBottom: "3px solid rgba(128, 128, 128, 0.5)",
        marginBottom: 5,
      },
    },
    localization: _localization,
    enableRowSelection: true,
    getRowId: (row) => row.id?.toString(),
    initialState: {
      showColumnFilters: false,
      columnPinning: {
        // left: ["mrt-row-numbers", "maVt"],
        // right: ["action"],
        ...columnPinning,
      },
      columnVisibility: { id: true, phone: false, fax: false },
      density: "xs",
    },
    mantineTableContainerProps: {
      style: { maxHeight: height, minHeight: height },
    },
    enableStickyHeader: true,
    manualPagination: true,
    onColumnPinningChange: (newState) => {
      setColumnPinning(newState);
    },
    onRowSelectionChange: setRowSelection,
    rowCount: rowCount,
    onPaginationChange: setPagination,
    mantineTableBodyCellProps: ({ row }) => ({
      style: {
        fontWeight: "500", //conditional styling
        fontSize: "12.5px",
        padding: "5px 15px",
      },
    }),
    state: {
      isLoading,
      pagination: pagination,
      showAlertBanner: isError,
      showProgressBars: isRefetching,
      showSkeletons: isLoading, //loading for the first time with no data
      rowSelection,
      columnPinning,
    },
    mantineToolbarAlertBannerProps: isError
      ? { color: "red", children: "Lỗi tải dữ liệu !" }
      : undefined,
    mantinePaginationProps: {
      showRowsPerPage: true,
      withEdges: true,
      rowsPerPageOptions: ["20", "50", "100"],
    },
    paginationDisplayMode: "pages",
    enableColumnPinning: true,
    mantineTableProps: {
      striped: false,
    },
    columnFilterDisplayMode: "popover",
    mantineTableBodyRowProps: ({ row }) => ({
      style: { cursor: "pointer" },
    }),
  });

  useHotkeys([
    [
      "Enter",
      () => {
        fetchData();
      },
    ],
  ]);

  return (
    <>
      <div
        ref={headerRef}
        style={{
          width: "100%",
        }}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 5 }}
          loaderProps={{
            children: (
              <Flex direction={"column"} align="center" gap="xs">
                <Loader type="dots" size={35}></Loader>
                {/* <Title size={15}> Đang upload tài liệu...</Title> */}
                <Title size={15}> Đang xử lý....</Title>
              </Flex>
            ),
          }}
        />
        <Flex justify={"space-between"} align={"center"} w={"100%"}>
          <_breadcrumb></_breadcrumb>
          <Flex gap={"md"}>
            {/* <Button
                leftSection={<IconFileTypeCsv size={16} />}
                onClick={() => exportDataExcel()}
              >
                Export Excel
              </Button> */}
          </Flex>
        </Flex>
        <Grid mt={10} w={"100%"}>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ khóa tìm kiếm"
              defaultValue={keySearch}
              onChange={(e) => setKeySearch(e.currentTarget.value)}
              leftSection={<IconSearch color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Từ ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.StartTime && search.StartTime?.length > 0
                  ? new Date(search.StartTime ?? "")
                  : null
              }
              maxDate={
                search.EndTime && search.EndTime?.length > 0
                  ? new Date(search.EndTime)
                  : new Date()
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "StartTime",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <DatePickerInput
              size="sm"
              placeholder="Đến ngày"
              locale="vi"
              valueFormat="DD/MM/YYYY"
              clearable
              value={
                search.EndTime && search.EndTime?.length > 0
                  ? new Date(search.EndTime ?? "")
                  : null
              }
              minDate={
                search.StartTime && search.StartTime?.length > 0
                  ? new Date(search.StartTime)
                  : undefined
              }
              onChange={(e) => {
                changeSearchValue(
                  e
                    ? new Date(
                        new Date(e).getTime() + 7 * 3600 * 1000
                      )?.toISOString()
                    : "",
                  "EndTime",
                  setSearch
                );
              }}
              leftSection={<IconCalendar color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <TextInput
              placeholder="Nhập từ số chứng từ"
              defaultValue={SoCt}
              onChange={(e) => setSoCt(e.currentTarget.value)}
              leftSection={<IconClipboard color="#15aabf" />}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  fetchData();
                }
              }}
            />
          </Grid.Col>
          {/* <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Select
              placeholder="Trạng thái"
              leftSection={<IconStatusChange color="#15aabf" />}
            />
          </Grid.Col> */}
          <Grid.Col span={{ base: 12, xs: 12, md: 6, lg: 2 }}>
            <Button
              onClick={() => fetchData()}
              leftSection={<IconSearch size={14} />}
            >
              Tìm kiếm
            </Button>
          </Grid.Col>
        </Grid>
      </div>
      <Box mt={10}>
        <MantineReactTable table={table} />
      </Box>
    </>
  );
};

export default PurchaseOrderReportExcludingPriceInformation;
